import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Switch from '../../formElements/Switch';

const MandatoryActivitiesSwitch = ({ isMandatory = false, onSwitch, disabled = false }) => {
    // STORE STATE
    const currentParticipant = useSelector(
        (state) => state.entities.participantService.currentParticipant
    );

    // RENDER
    return (
        <div>
            <Switch
                id="isAppointmentMandatory"
                label="Mandatory"
                leftLabel="No"
                rightLabel="Yes"
                disabled={
                    (!currentParticipant?.allowMandatoryActivities && !isMandatory) || disabled
                }
                checked={isMandatory}
                onChange={(e) => onSwitch('mandatory', e.target.checked)}
            />
        </div>
    );
};

MandatoryActivitiesSwitch.propTypes = {
    isMandatory: PropTypes.bool,
    onSwitch: PropTypes.func,
    disabled: PropTypes.bool
};

export default MandatoryActivitiesSwitch;
